import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import env from './utils/env'
import './i18n' // Initialize i18n before importing App
import App from './App.tsx'

// Initialize Sentry for error tracking and performance monitoring
Sentry.init({
  dsn: env.sentryDsn,
  environment: env.sentryEnvironment || 'development',
  release: env.sentryRelease || 'unknown',
  tracesSampleRate: env.sentryEnvironment === 'production' ? 0.1 : 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  beforeSend(event) {
    // Don't send events in development if no DSN is provided
    if (!env.sentryDsn && env.isDev) {
      return null;
    }
    return event;
  },
  integrations: [
    Sentry.replayIntegration(),
    Sentry.browserTracingIntegration(),
    Sentry.contextLinesIntegration(),
  ],
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
